"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = void 0;

var _uuid = require("uuid");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Event {
  constructor(name, properties) {
    _defineProperty(this, "messageId", void 0);

    _defineProperty(this, "name", void 0);

    _defineProperty(this, "properties", void 0);

    _defineProperty(this, "time", void 0);

    this.name = name;
    this.properties = properties || {};
    this.time = Date.now();
    this.messageId = (0, _uuid.v4)();
  }

}

exports.Event = Event;